<script lang="ts" setup>
import type { PayPageConfig } from '../configs/types'
import { getPayPageConfig } from '../configs/brands'
import { useI18n } from '@/composables/useI18n'

defineProps<{
  item: any
  isActive?: boolean
}>()

const { t } = useI18n()

// 加载当前品牌的 pay 配置
const config: PayPageConfig = getPayPageConfig()
</script>

<template>
  <div class="purchase-item-novelarc">
    <!-- Popular 标签 -->
    <div
      v-if="item.cornerTip === 1 && item.marketingText"
      class="popular-tag"
    >
      {{ item.marketingText }}
    </div>

    <!-- 左侧内容 -->
    <div class="card-left">
      <!-- 金币图标 + 数量 -->
      <div class="coins-row">
        <img :src="config.resources?.goldCoinIcon || '/images/novelarc/welfare-gold.png'" class="coin-icon" alt="">
        <span class="coins-amount">{{ item.coinsBuy }}+{{ item.coinsBonus }}</span>
      </div>

      <!-- 描述文字（+100Coins）和百分比标签 -->
      <div class="desc-row">
        <span v-if="item.coinsBonus" class="bonus-text">+{{ item.coinsBonus }}{{ config.texts?.coins || t('Coins') }}</span>
        <span v-if="item.cornerTip" class="bonus-tag">+{{ parseFloat((item.coinsBonus / item.coinsBuy * 100).toFixed(0)) }}%</span>
      </div>
    </div>

    <!-- 右侧价格按钮 -->
    <div class="card-right">
      <div class="price-btn">
        $ {{ item.price }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.purchase-item-novelarc {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 91PX;
  padding: 8px 14px;
  box-sizing: border-box;
  border-radius: 8px;
  overflow: hidden;
}

.popular-tag {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #FF4754 0%, #FEA94C 100%);
  border-radius: 8px 100px 100px 0;
  font-weight: 500;
  font-size: 10px;
  color: #fff;
}

.card-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card-right {
  flex-shrink: 0;
}

.coins-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.coin-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.coins-amount {
  font-weight: 500;
  font-size: 20px;
  color: #633329;
}

.desc-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.bonus-text {
  font-weight: 500;
  font-size: 12px;
  color: #A56E4A;
}

.bonus-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 18px;
  padding: 0 6px;
  border-radius: 10px;
  border: 1px solid #A56E4A;
  font-weight: 500;
  font-size: 10px;
  color: #A56E4A;
  line-height: 10px;
  box-sizing: border-box;
}

.price-btn {
  min-width: 81px;
  height: 32px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #F7A82A 0%, #FE7E01 100%);
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}
</style>
